export default "__VITE_ASSET__D70HzEIU__"